module.exports = __webpack_public_path__ + "static/media/mago.9c6e28c8.png";